import { render, staticRenderFns } from "./Expert.vue?vue&type=template&id=50a26c33&"
import script from "./Expert.vue?vue&type=script&lang=js&"
export * from "./Expert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports